export default __webpack_public_path__ + "static/media/car-house.1e15be5b.png";